import { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import CloseIcon from '@mui/icons-material/Close';
import { Drawer, Typography, IconButton, TextField, MenuItem, Button, Box, Select, Tab } from '@mui/material';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { Controller, useForm } from 'react-hook-form';
import { TabContext, TabList } from '@mui/lab';
import { useGetCategoryQuery, useGetPartnersQuery } from 'widgets/product/ui/api/getShopsApi';
import { useGetCitiesQuery } from 'features/getCities/api/getCitiesApi';
import { toast } from 'react-toastify';
import { useGetCountriesQuery } from 'features/getCountries/api/getCountriesApi';
import { useCreateImageMutation } from 'widgets/product/ui/api/productImageApi';
import { useUpdateProductLocalizationMutation } from 'widgets/product/ui/api/productLocalizationApi';
import { useUpdateAvailableProductMutation } from 'widgets/product/ui/api/availableProductApi';
import { ShopType } from 'widgets/product/model/types';

type DrawerChangeProductType = {
  product: ShopType | undefined;
};

type FormDataType = {
  city_scope: any[];
  category_id: number;
  partner_id: number;
  product_type: string;
  language: string;
  contents: any[];
  available_products: any[];
  price: number;
  price2: number;
  price3: number;
};

export const DrawerChangeProduct = (request: DrawerChangeProductType) => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);

  const [createImageRequest] = useCreateImageMutation();
  const [putProductLocalizationRequest] = useUpdateProductLocalizationMutation();
  const [putAvailableProductRequest] = useUpdateAvailableProductMutation();

  const { data: countryList } = useGetCountriesQuery(null);

  const { data: categoryList } = useGetCategoryQuery({
    per_page: 100,
    page: 1,
    order: 1,
  });
  const { data: productList } = useGetPartnersQuery({
    per_page: 100,
    page: 1,
    order: 1,
  });
  const { data: cityList } = useGetCitiesQuery({});

  const {
    getValues,
    control,
    formState: { errors: formErrors },
  } = useForm<FormDataType>({
    defaultValues: {
      contents: [
        {
          language_id: 1,
          title: '',
          description: '',
          image: '',
        },
        {
          language_id: 2,
          title: '',
          description: '',
          image: '',
        },
        {
          language_id: 3,
          title: '',
          description: '',
          image: '',
        },
        {
          language_id: 4,
          title: '',
          description: '',
          image: '',
        },
        {
          language_id: 5,
          title: '',
          description: '',
          image: '',
        },
      ],
    },
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const handleChange = (event: any) => {
    setFileName(event.target.files[0].name);
    setSelectedFile(event.target.files[0]);
  };
  const handleUploadClick = async (index: number) => {
    if (!selectedFile) {
      return;
    }
    const formData = new FormData();
    formData.append('image', selectedFile);

    createImageRequest(formData)
      .then((response) => {
        if ('error' in response) {
          toast.error('Произошла ошибка при сохранении файла', {
            position: toast.POSITION.TOP_RIGHT,
          });
          return;
        }

        if ('data' in response && response.data.image_reference != null) {
          const data2 = getValues();
          data2.contents[index].image = response.data.image_reference;
          toast.success('Файл успешно сохранен', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        toast.error('Произошла ошибка при сохранении файла', {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };
  const localCityList = { items: [] as any };

  const ChangeLocal = async (request: any) => {
    putProductLocalizationRequest(request)
      .then((response) => {
        if ('error' in response) {
          toast.error('Произошла ошибка при изменении товара', {
            position: toast.POSITION.TOP_RIGHT,
          });
          return;
        }

        if ('data' in response && response.data.product_id != null) {
          toast.success('Товар успешно изменен', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        toast.error('Произошла ошибка при изменении товара', {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const ChangePrice = async (request: any) => {
    putAvailableProductRequest(request)
      .then((response) => {
        if ('error' in response) {
          toast.error('Произошла ошибка при изменении товара', {
            position: toast.POSITION.TOP_RIGHT,
          });
          return;
        }
        if ('data' in response && response.data.product_id != null) {
          toast.success('Товар успешно изменен', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        toast.error('Произошла ошибка при изменении товара', {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleChangeCountry = (event: { target: { value: any } }) => {
    const {
      target: { value },
    } = event;

    setCountry(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleChangeCity = (event: { target: { value: any } }) => {
    const {
      target: { value },
    } = event;

    setCities(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  const [country, setCountry] = useState([]);
  const [cities, setCities] = useState([]);

  cityList?.map((item) => {
    country.map((c) => {
      if (item.country_id === c) {
        localCityList.items.push({ name: item.name, id: item.id });
      }
    });
  });

  const city_scope = [] as any;

  const handleCreateProduct = async () => {
    const data = getValues();

    cities.map((item) => {
      city_scope.push({
        title: item,
      });
    });

    /// /////////////////AVAILABLE PRODUCTS////////////////////////////////////////////////////////
    const { product } = request;
    if (data.price !== product?.available_products.find((c) => c.country === 'Казахстан')?.price) {
      const req = {
        available_product_id: product?.available_products.find((c) => c.country === 'Казахстан')?.available_product_id,
        price: data.price,
        country: 'Казахстан',
      };
      ChangePrice(req);
    }

    if (data.price2 !== product?.available_products.find((c) => c.country === 'Кыргызстан')?.price) {
      const req = {
        available_product_id: product?.available_products.find((c) => c.country === 'Кыргызстан')?.available_product_id,
        price: data.price2,
        country: 'Кыргызстан',
      };
      ChangePrice(req);
    }

    if (
      data.price3 !==
      product?.available_products.find((c) => c.country === 'Узбекcтан' || c.country === 'Узбекиcтан')?.price
    ) {
      const req = {
        available_product_id: product?.available_products.find(
          (c) => c.country === 'Узбекcтан' || c.country === 'Узбекиcтан',
        )?.available_product_id,
        price: data.price3,
        country: 'Узбекcтан',
      };
      ChangePrice(req);
    }

    /// /////////////////////////////// LOCAL/////////////////////////////////////////
    if (
      data.contents[0].title !== product?.localizations.find((c) => c.language === 'RU')?.localization_title ||
      data.contents[0].description !== product?.localizations.find((c) => c.language === 'RU')?.description ||
      data.contents[0].image !== product?.localizations.find((c) => c.language === 'RU')?.image
    ) {
      const req = {
        localization_id: product?.localizations.find((c) => c.language === 'RU')?.localization_id,
        language: 'RU',

        title:
          data.contents[0].title !== ''
            ? data.contents[0].title
            : product?.localizations.find((c) => c.language === 'RU')?.localization_title,

        description:
          data.contents[0].description !== ''
            ? data.contents[0].description
            : product?.localizations.find((c) => c.language === 'RU')?.description,

        image:
          data.contents[0].image !== ''
            ? data.contents[0].image
            : product?.localizations.find((c) => c.language === 'RU')?.image,
      };
      ChangeLocal(req);
    }

    if (
      data.contents[1].title !== product?.localizations.find((c) => c.language === 'KZ')?.localization_title ||
      data.contents[1].description !== product?.localizations.find((c) => c.language === 'KZ')?.description ||
      data.contents[1].image !== product?.localizations.find((c) => c.language === 'KZ')?.image
    ) {
      const req = {
        localization_id: product?.localizations.find((c) => c.language === 'KZ')?.localization_id,
        language: 'RU',
        title:
          data.contents[1].title !== ''
            ? data.contents[1].title
            : product?.localizations.find((c) => c.language === 'KZ')?.localization_title,

        description:
          data.contents[1].description !== ''
            ? data.contents[1].description
            : product?.localizations.find((c) => c.language === 'KZ')?.description,

        image:
          data.contents[1].image !== ''
            ? data.contents[0].image
            : product?.localizations.find((c) => c.language === 'KZ')?.image,
      };
      ChangeLocal(req);
    }

    if (
      data.contents[2].title !== product?.localizations.find((c) => c.language === 'EN')?.localization_title ||
      data.contents[2].description !== product?.localizations.find((c) => c.language === 'EN')?.description ||
      data.contents[2].image !== product?.localizations.find((c) => c.language === 'EN')?.image
    ) {
      const req = {
        localization_id: product?.localizations.find((c) => c.language === 'EN')?.localization_id,
        language: 'EN',

        title:
          data.contents[2].title !== ''
            ? data.contents[2].title
            : product?.localizations.find((c) => c.language === 'EN')?.localization_title,

        description:
          data.contents[2].description !== ''
            ? data.contents[2].description
            : product?.localizations.find((c) => c.language === 'EN')?.description,

        image:
          data.contents[2].image !== ''
            ? data.contents[2].image
            : product?.localizations.find((c) => c.language === 'EN')?.image,
      };
      ChangeLocal(req);
    }
    if (
      data.contents[3].title !== product?.localizations.find((c) => c.language === 'KG')?.localization_title ||
      data.contents[3].description !== product?.localizations.find((c) => c.language === 'KG')?.description ||
      data.contents[3].image !== product?.localizations.find((c) => c.language === 'KG')?.image
    ) {
      const req = {
        localization_id: product?.localizations.find((c) => c.language === 'KG')?.localization_id,
        language: 'KG',
        title:
          data.contents[3].title !== ''
            ? data.contents[3].title
            : product?.localizations.find((c) => c.language === 'KG')?.localization_title,

        description:
          data.contents[3].description !== ''
            ? data.contents[3].description
            : product?.localizations.find((c) => c.language === 'KG')?.description,

        image:
          data.contents[3].image !== ''
            ? data.contents[3].image
            : product?.localizations.find((c) => c.language === 'KG')?.image,
      };
      ChangeLocal(req);
    }
    if (
      data.contents[4].title !== product?.localizations.find((c) => c.language === 'UZ')?.localization_title ||
      data.contents[4].description !== product?.localizations.find((c) => c.language === 'UZ')?.description ||
      data.contents[4].image !== product?.localizations.find((c) => c.language === 'UZ')?.image
    ) {
      const req = {
        localization_id: product?.localizations.find((c) => c.language === 'KG')?.localization_id,
        language: 'UZ',
        title:
          data.contents[4].title !== ''
            ? data.contents[4].title
            : product?.localizations.find((c) => c.language === 'UZ')?.localization_title,

        description:
          data.contents[4].description !== ''
            ? data.contents[4].description
            : product?.localizations.find((c) => c.language === 'UZ')?.description,

        image:
          data.contents[4].image !== ''
            ? data.contents[4].image
            : product?.localizations.find((c) => c.language === 'UZ')?.image,
      };
      ChangeLocal(req);
    }

    /// ////////////////////////////////////////////PRICE////////////////////////////////////
  };

  const [tabValue, setTabValue] = useState('0');
  const handleChangeTabValue = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const [initState] = useState({
    directions: [],
    b2b_directions: [],
    b2b_tiers: [],
    countries: '',
    cities: '',
    contents: [
      {
        language: 1,
        title: '',
        description: '',
        image: '',
      },
      {
        language: 2,
        title: '',
        description: '',
        image: '',
      },
      {
        language: 3,
        title: '',
        description: '',
        image: '',
      },
      {
        language: 4,
        title: '',
        description: '',
        image: '',
      },
      {
        language: 5,
        title: '',
        description: '',
        image: '',
      },
    ],
    priority: 0,
  });

  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ marginTop: '16px' }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  };

  const mystyle = {
    color: 'transparent',
  };

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            Изменить товар
          </Typography>
          <IconButton
            onClick={() => dispatch(setDrawerOpen(false))}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          <div>
            <Controller
              control={control}
              name="language"
              render={() => (
                <Box sx={{ width: '100%' }}>
                  <TabContext value={tabValue}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <TabList
                        onChange={handleChangeTabValue}
                        aria-label="basic tabs example"
                      >
                        <Tab
                          value="0"
                          label="RU"
                          {...a11yProps(0)}
                        />
                        <Tab
                          value="1"
                          label="KK"
                          {...a11yProps(1)}
                        />
                        <Tab
                          value="2"
                          label="EN"
                          {...a11yProps(2)}
                        />
                        <Tab
                          value="3"
                          label="KG"
                          {...a11yProps(3)}
                        />
                        <Tab
                          value="4"
                          label="UZ"
                          {...a11yProps(4)}
                        />
                      </TabList>
                    </Box>
                    {initState.contents.map((item, index) => (
                      <TabPanel
                        value={+tabValue}
                        index={index}
                      >
                        <Controller
                          control={control}
                          name={`contents.${index}.title`}
                          render={({ field }) => (
                            <TextField
                              value={field.value}
                              onChange={(e) => field.onChange(e)}
                              label="Название товара"
                              size="small"
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              sx={{
                                marginBottom: '24px',
                              }}
                            />
                          )}
                        />
                        <Controller
                          control={control}
                          name={`contents.${index}.description`}
                          render={({ field }) => (
                            <TextField
                              value={field.value}
                              onChange={(e) => field.onChange(e)}
                              multiline
                              rows={4}
                              label="Описание товара"
                              size="small"
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              sx={{
                                marginBottom: '24px',
                              }}
                            />
                          )}
                        />
                        <Controller
                          control={control}
                          name={`contents.${index}.image`}
                          render={() => (
                            <input
                              type="file"
                              style={mystyle}
                              onChange={handleChange}
                            />
                          )}
                        />

                        <Button
                          onClick={() => {
                            handleUploadClick(index);
                          }}
                        >
                          Сохранить файл
                        </Button>
                        {fileName ? <div>{fileName}</div> : ''}
                      </TabPanel>
                    ))}
                  </TabContext>
                </Box>
              )}
            />
          </div>
          <br />
          <div>
            <Box sx={{ width: '100%' }}>
              <Typography>Детали товара</Typography>
              <div style={{ margin: '16px 0 16px 0' }} />
              <Controller
                name="category_id"
                control={control}
                render={({ field }) => (
                  <TextField
                    select
                    type="text"
                    label="Категория"
                    placeholder=""
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      marginBottom: '24px',
                    }}
                    error={formErrors.language && true}
                    {...field}
                  >
                    {categoryList?.map((cat) => (
                      <MenuItem value={cat.product_category_id}>{cat.title_ru}</MenuItem>
                    ))}
                  </TextField>
                )}
              />

              <Controller
                name="partner_id"
                control={control}
                render={({ field }) => (
                  <TextField
                    select
                    type="text"
                    label="Партнёр"
                    placeholder=""
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      marginBottom: '24px',
                    }}
                    error={formErrors.language && true}
                    {...field}
                  >
                    {productList?.map((prod) => (
                      <MenuItem value={prod.partner_id}>{prod.description_ru}</MenuItem>
                    ))}
                  </TextField>
                )}
              />
              <div>Страна</div>
              <Select
                multiple
                type="number"
                value={country}
                onChange={handleChangeCountry}
                placeholder=""
                fullWidth
                size="small"
                sx={{
                  marginBottom: '24px',
                }}
              >
                {countryList ? (
                  countryList.map((item) => (
                    <MenuItem
                      value={item.id}
                      key={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem>loading</MenuItem>
                )}
              </Select>

              <div>Город</div>
              <Select
                multiple
                type="number"
                value={cities}
                onChange={handleChangeCity}
                placeholder=""
                fullWidth
                size="small"
                sx={{
                  marginBottom: '24px',
                }}
              >
                {localCityList ? (
                  localCityList.items.map((item: any) => (
                    <MenuItem
                      value={item.name}
                      key={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem>loading</MenuItem>
                )}
              </Select>

              <Controller
                name="product_type"
                control={control}
                render={({ field }) => (
                  <TextField
                    select
                    type="text"
                    label="Товар доступен для направления"
                    placeholder=""
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      marginBottom: '24px',
                    }}
                    {...field}
                  >
                    <MenuItem
                      value={0}
                      key={0}
                    >
                      Физический
                    </MenuItem>
                    <MenuItem
                      value={1}
                      key={1}
                    >
                      Виртуальный
                    </MenuItem>
                  </TextField>
                )}
              />

              <Controller
                name="price"
                control={control}
                render={({ field }) => (
                  <TextField
                    type="number"
                    label="Казахстан: стоимость единицы товара"
                    placeholder=""
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      marginBottom: '24px',
                    }}
                    {...field}
                  />
                )}
              />
              <Controller
                name="price2"
                control={control}
                render={({ field }) => (
                  <TextField
                    type="number"
                    label="Кыргызстан: стоимость единицы товара"
                    placeholder=""
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      marginBottom: '24px',
                    }}
                    {...field}
                  />
                )}
              />

              <Controller
                name="price3"
                control={control}
                render={({ field }) => (
                  <TextField
                    type="number"
                    label="Узбекистан: стоимость единицы товара"
                    placeholder=""
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      marginBottom: '24px',
                    }}
                    {...field}
                  />
                )}
              />
            </Box>
          </div>

          <Box
            sx={{
              display: 'flex',
              marginTop: '30px',
            }}
          >
            <Button
              variant="contained"
              sx={{ textTransform: 'none' }}
              onClick={handleCreateProduct}
            >
              Создать
            </Button>
          </Box>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
